module.exports = __webpack_public_path__ + "assets/img/targeting-mid.ffa48e20.svg";